import React from "react";

function BlogArticle({ article }) {
  const paragraphs = article.content.trim().split(/\n\s*\n/).filter(Boolean);

  return (
    <article
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        lineHeight: 1.9,
        color: "#334155",
        fontSize: "1.05rem",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "12px",
          flexWrap: "wrap",
          color: "#64748b",
          marginBottom: "30px",
          fontSize: ".95rem",
        }}
      >
        <span>{article.publishDate}</span>
        <span>•</span>
        <span>{article.readTime}</span>
        {article.authorRole && (
          <>
            <span>•</span>
            <span>{article.authorRole}</span>
          </>
        )}
      </div>

      {article.takeaways?.length > 0 && (
        <div
          style={{
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
            borderRadius: "20px",
            padding: "24px",
            marginBottom: "32px",
          }}
        >
          <div
            style={{
              color: "#21b573",
              fontWeight: 700,
              marginBottom: "16px",
              fontSize: ".85rem",
              letterSpacing: ".12em",
              textTransform: "uppercase",
            }}
          >
            Key takeaways
          </div>

          <div
            style={{
              display: "grid",
              gap: "12px",
            }}
          >
            {article.takeaways.map((takeaway) => (
              <div
                key={takeaway}
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "flex-start",
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    marginTop: "10px",
                    borderRadius: "999px",
                    background: "#21b573",
                    flexShrink: 0,
                  }}
                />
                <span>{takeaway}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div
        style={{
          display: "grid",
          gap: "18px",
        }}
      >
        {paragraphs.map((paragraph) => (
          <p key={paragraph} style={{ margin: 0 }}>
            {paragraph}
          </p>
        ))}
      </div>
    </article>
  );
}

export default BlogArticle;
